/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

const componentName = 'id-wall';
class IdWall extends Component {
    elements = {
        signInLink: this.element.querySelector(`.${componentName}__cta`),
        content: this.element.querySelector(`.${componentName}__content`),
        // Hero Banner
        heroBanner: document.querySelector('.hero-banner__container'),
        shards1: document.querySelectorAll('.hero-banner__shard-1'),
        shards2: document.querySelectorAll('.hero-banner__shard-2'),
        shards3: document.querySelectorAll('.hero-banner__shard-3'),
        shards4: document.querySelectorAll('.hero-banner__shard-4'),
        shards5: document.querySelectorAll('.hero-banner__shard-5'),
        buttonsContainer: document.querySelector('.hero-banner__buttons-container'),
    };

    constants = {
        buttonStyleIds: {
            // Button Type styles
            'button-primary': 'button--primary',
            'button-outline': 'button--outline',
            'button-text': 'button--text',
            'button--grid-padding-text': 'button--grid-padding-text',
            'button--no-padding-text': 'button--no-padding-text',
            // Button Color styles
            'button--color-default': 'button--color-default',
            'button--color-inverted': 'button--color-inverted',
            // Button Margin styles
            'push-top-full': 'push-top-full',
            'push-top-half': 'push-top-half',
            'push-top-small': 'push-top-small',
            'push-bottom-full': 'push-bottom-full',
            'push-bottom-half': 'push-bottom-half',
            'push-bottom-small': 'push-bottom-small',
            // Button Type (LEGACY) styles
            primary: 'primary',
            'primary-outline': 'primary-outline',
            secondary: 'secondary',
            'secondary-outline': 'secondary-outline',
            'transparent-white': 'transparent-white',
        },
    };

    initDom = () => {
        this.initSignInLink();
        this.initHeroBanner();
        this.initHeroBannerChild();
        this.initHeroBannerAnimation();
    };

    getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    checkSignInStatus = () => {
        // If user is signed in, redirect to page without the id-wall selector
        if (window.userData || window.localStorage.getItem('loggedInData')) {
            // Check if piraPass cookie exists
            const piraPassCookie = this.getCookie('piraPass');

            // If logged in but no piraPass cookie, redirect to login page
            if (!piraPassCookie) {
                // Check if there's a sign-in element to click
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else if (localStorage.getItem('adfsLogin')) {
                    // Use ADFS login URL if available
                    window.location.href = localStorage.getItem('adfsLogin');
                } else {
                    // Default login page redirect
                    window.location.href = '/en-us/login';
                }
                return;
            }

            const url = window.location.href;
            const newUrl = url.replace('.preview.', '.');
            if (newUrl !== url) {
                window.location.href = newUrl;
            }
        }
    };

    initSignInLink = () => {
        this.elements.signInLink.addEventListener('click', () => {
            if (document.querySelector('.account-menu__sign-in')) {
                document.querySelector('.account-menu__sign-in').click();
            } else if (localStorage.getItem('adfsLogin')) {
                window.location.href = localStorage.getItem('adfsLogin');
            }
        });
    };

    initHeroBanner = () => {
        const { heroBannerSubtitle } = this.elements.content.dataset;
        const { heroBannerTitle } = this.elements.content.dataset;
        const { heroBannerCopy } = this.elements.content.dataset;
        const { heroBannerImagePath } = this.elements.content.dataset;
        const { heroBannerImageAlt } = this.elements.content.dataset;

        if (heroBannerSubtitle) {
            this.elements.heroBanner.querySelector('.hero-banner__subtitle-text').textContent = heroBannerSubtitle;
        }
        if (heroBannerTitle) {
            this.elements.heroBanner.querySelector('.hero-banner__title').textContent = heroBannerTitle;
        }
        if (heroBannerCopy) {
            this.elements.heroBanner.querySelector('.hero-banner__copy-text').textContent = heroBannerCopy;
        }
        if (heroBannerImagePath) {
            this.elements.heroBanner.removeAttribute('data-no-media');
            const heroBannerImage = document.createElement('div');
            heroBannerImage.classList.add('hero-banner__media-wrapper');
            const heroBannerImageHtml = `<div class="hero-banner__media-mask-wrapper">
                                            <svg>
                                                <clipPath id="hero-banner__media-mask" clipPathUnits="objectBoundingBox">
                                                    <path d="M1,0 H0.433 C0.417,-0.001,0.401,0.014,0.39,0.04 C0.332,0.17,0.266,0.325,0.2,0.481 C0.133,0.638,0.066,0.795,0.008,0.925 C0.007,0.929,0.005,0.933,0.004,0.937 C0,0.948,-0.001,0.964,0.002,0.977 C0.006,0.995,0.012,1,0.021,1 H0.493 H1 V0"></path>
                                                </clipPath>
                                            </svg>
                                        </div>
                                        <picture class=" aspect-ratio--16x9">
                                                <source srcset="${heroBannerImagePath}">
                                                <img class="hero-banner__image  main-image" width="2400" height="auto" src="${heroBannerImagePath}" alt="${heroBannerImageAlt}" data-trackable="true">
                                        </picture>`;
            heroBannerImage.innerHTML = heroBannerImageHtml;
            this.elements.heroBanner.querySelector('.hero-banner__media-container').insertAdjacentElement('afterBegin', heroBannerImage);
        }
    };

    initHeroBannerChild = () => {
        const { heroBannerChildType } = this.elements.content.dataset;
        const { heroBannerChildLabel } = this.elements.content.dataset;
        const { heroBannerChildPath } = this.elements.content.dataset;
        const { heroBannerChildStyleIds } = this.elements.content.dataset;

        if (heroBannerChildType === 'cta') {
            const button = document.createElement('span');
            button.classList.add('button');
            if (heroBannerChildStyleIds) {
                heroBannerChildStyleIds.split(' ').forEach((styleId) => {
                    if (this.constants.buttonStyleIds[styleId]) {
                        button.classList.add(this.constants.buttonStyleIds[styleId]);
                    }
                });
            }
            const buttonHtml = `<a href="${heroBannerChildPath}" target="_self" data-link-type="cta" data-link-text="${heroBannerChildLabel.toLowerCase()}">
                                    <span> 
                                        ${heroBannerChildLabel}
                                    </span>
                                </a>`;
            button.innerHTML = buttonHtml;
            this.elements.buttonsContainer.appendChild(button);
        }
    };

    initHeroBannerAnimation = () => {
        if (this.elements.shards1.length < 1) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);
        const scrollTrigger = {
            trigger: this.elements.heroBanner,
            start: 'top 0px',
            end: 'bottom top',
            scrub: true
        };

        const gsapToIfExists = (target, vars) => {
            if (target) {
                gsap.to(target, vars);
            }
        };

        gsapToIfExists(this.elements.textContainer, { y: 150, scrollTrigger });
        gsapToIfExists(this.elements.shards1, { y: -100, scrollTrigger });
        gsapToIfExists(this.elements.shards2, { y: -550, scrollTrigger });
        gsapToIfExists(this.elements.shards3, { y: 60, scrollTrigger });
        gsapToIfExists(this.elements.shards4, { y: 400, scrollTrigger });
        gsapToIfExists(this.elements.shards5, { y: 600, scrollTrigger });
        gsapToIfExists(document.querySelector('.hero-banner__image'), { scale: 1.4, scrollTrigger });
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.checkSignInStatus();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.checkSignInStatus();
            });
        }
    };
}

registerComponent(`.${componentName}__container`, IdWall);
